/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import LeaveAdvanceEncashmentARModalController from '../../Modals/ActionRequiredModals/LeaveAdvanceEncashmentARModal/LeaveAdvanceEncashmentARModalController';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { useTranslate } from '../../../hooks';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { DateField } from '../../../components';
import { leavesService } from '../../../api/services/leavesService';
import { setAllLeaveHistory } from '../../../infra/aggregates/myProfile/leavesAggregates/leaveHistorySlice';

interface Propval {
  trans: any;
}

const LeaveAdvanceEncashment = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [leaveData, setLeaveData] = useState([])
  const [empLeaveHistoryData,setEmpLeaveHistoryData] = useState([])

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  const handelViewAction = (x: any) =>{
    leavesService
     .getEmployeeLeaveHistoryWithYear(
        x?.company_id,
        x?.emp_id,
        0,
        "Leave Encashment"
      )
      .then((res)=>{
        if (res) {
          dispatch(setAllLeaveHistory(res.data));
          setEmpLeaveHistoryData(res.data);
        } 
      })
    setLeaveData(x)
  }

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('#Emp Id'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name={params?.row?.empName} picture={params?.row?.profile_picture} />;
      },
    },
    {
      field: 'leaveType',
      headerName: trans('Leave Type'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'applied On',
      headerName: trans('Applied On'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell:(params: any)=>{
        return params?.row?.applied_on ? (
          <DateField
            value={params?.row?.applied_on}
            offset={0}
            format={baseDateFormatting}
          />
        ) : (
          '--'
        );
      },
    },

    {
      field: 'from',
      headerName: trans('From'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any)=>{
        return params?.row?.from ? 
        (
          <DateField 
          value={params?.row?.from}
          offset={0}
          format={baseDateFormatting}
          />
        ) : (
          '--'
        )
      }
    },
    {
      field: 'to',
      headerName: trans('To'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any)=>{
        return params?.row?.to ? 
        (
          <DateField 
          value={params?.row?.to}
          offset={0}
          format={baseDateFormatting}
          />
        ) : (
          '--'
        )
      }
    },
    {
      field: 'days',
      headerName: trans('Days'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'amount',
      headerName: trans('Amount'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'status',
      headerName: trans('Status'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handelViewAction(params?.row?.full_data)
              setOpenModal(true);
            }}
          />
        );
      },

      height: 70,
    },
  ];

  const getStatus = ["pending","Approved","Rejected"]
  const row_data = _.map(storedARData,function(e:any){
    return{
      id:e?.id,
      empId: `#${e?.staff_id}`,
      profile_picture: `#${e?.attachment}`,
      empName: `${e?.first_name} ${e?.last_name}`,
      last_name:e?.last_name,
      leaveType:e?.leaveType,
      applied_on:e?.applied_on,
      from:e?.start_date,
      to:e?.end_date,
      days:e?.total_leave_days,
      amount:e?.amount,
      status:getStatus[e?.status],
      full_data:e
    }
  })

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <LeaveAdvanceEncashmentARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          leaveEncash_Data={leaveData}
          leaveHistory={empLeaveHistoryData}
        />
      )}
    </>
  );
};

export default LeaveAdvanceEncashment;
